module.exports = "https://static.wmbcdn.com/uniweb/images/1446f6329479c24443588df47f5d7323.svg";